import { KeyOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { ProLayout } from "@ant-design/pro-components";
import { Dropdown } from "antd";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import logo from "../images/c1-logo-dark.svg";
import { logout } from "../../auth/helper-methods";
import { useAdminMenu } from "../hooks/useAdminMenu";

export const AdminLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const menu = useAdminMenu();

  const menuItemRender = (item: any, dom: any) =>
    item && item.path ? <Link to={item.path}> {dom} </Link> : dom;

  // Dynamic title based on route
  const getPageTitle = () => {
    if (location.pathname.includes("/surveys/stats")) {
      return "";
    }
    return "Survey Admin";
  };

  return (
    <ProLayout
      logo={<img src={logo} alt="logo" />}
      title={getPageTitle()}
      layout="mix"
      location={location}
      collapsedButtonRender={() => <></>}
      siderMenuType="sub"
      menuItemRender={menuItemRender}
      route={menu}
      avatarProps={{
        icon: <UserOutlined />,
        style: { backgroundColor: "#1E88E5" },
        render: (_props, dom) => (
          <>
            <Dropdown
              menu={{
                onClick: (e) => {
                  if (e.key === "logout") {
                    logout();
                  } else if (e.key === "change-password") {
                    navigate("/admin/change-password");
                  }
                },
                items: [
                  {
                    key: "change-password",
                    label: "Change Password",
                    icon: <KeyOutlined />,
                  },
                  {
                    type: "divider",
                  },
                  {
                    key: "logout",
                    label: "Logout",
                    icon: <LogoutOutlined />,
                  },
                ],
              }}
            >
              {dom}
            </Dropdown>
          </>
        ),
      }}
    >
      <Outlet />
    </ProLayout>
  );
};
